import { MOKA_MATCH_EVEN_WIN_PROBABILITY, MOKA_MATCH_MAXIMUM_WIN_PROBABILITY, MOKA_MATCH_MINIMUM_WIN_PROBABILITY } from "@/constants";
const getMokaFinalBlackWinProbability = score => {
  if (score > 0) {
    return MOKA_MATCH_MAXIMUM_WIN_PROBABILITY;
  }
  if (score < 0) {
    return MOKA_MATCH_MINIMUM_WIN_PROBABILITY;
  }
  return MOKA_MATCH_EVEN_WIN_PROBABILITY;
};
export { getMokaFinalBlackWinProbability };